<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="当事人:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="queryParams.zylb" clearable placeholder="请选择专业类别" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <el-button type="danger" v-if="xz == '1'" icon="el-icon-plus" size="small" @click="handleAdd">无证新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>单位数量:{{total}}</p>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="wdxdrList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="监督对象名称" prop="dwmc" />
                    <el-table-column label="专业类别" prop="zylb" />
                    <el-table-column label="单位地址" prop="dwdz" />
                    <el-table-column label="乡街道" prop="xiangjiedao" />
                    <el-table-column label="统一社会信用代码" prop="zzdm" />
                    <el-table-column label="负责人" align="center" prop="jingyingzheXm"  width="140"/>
                    <el-table-column label="手机1" align="center" prop="sj1" />
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row)"
                        >编辑</el-button>
                            <el-button v-if="sc=='1'"
                            size="small"
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="勾选" align="center" class-name="small-padding fixed-width"  width="80">
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >勾选</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="无证库" :visible.sync="open" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <h2 style="text-align:center;margin-bottom:10px;">当事人基本信息</h2>
                <el-form ref="form" :model="form" :rules="rules" label-width="160px">
                    <el-row>
                        <!-- <el-col :span="24">
                    <el-form-item label="微信选择:" prop="weixin">
                        <el-select v-model="form.weixin" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in weixinOptions"
                                :key="dict.openid"
                                :label="dict.nickname"
                                :value="dict.openid"
                                ></el-option>
                        </el-select>&nbsp;
                        <el-button type="primary" size="small" @click="getSfsb">接收身份证智能识别通知</el-button>
                    </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="性质:" prop="jingyingzhe">
                        <el-select v-model="form.jingyingzhe" placeholder="请选择" clearable size="small">
                            <!-- <el-option value="法定代表人">法定代表人</el-option>
                            <el-option value="经营者">经营者</el-option>
                            <el-option value="负责人">负责人</el-option>
                            <el-option value="个人">个人</el-option> -->
                            <el-option 
                                v-for="dict in jingyingzheOptions"
                                :key="dict.id"
                                :label="dict.jingyingzhe"
                                :value="dict.jingyingzhe"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item :label="form.jingyingzhe?(form.jingyingzhe=='个人'?'个人姓名:':form.jingyingzhe+':'):'负责人:'" prop="jingyingzheXm">
                        <el-input v-model="form.jingyingzheXm" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item label="单位名称:">
                        <el-input v-model="form.dwmc" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="专业类别:">
                        <el-select v-model="form.zylb" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                    <el-form-item label="姓名:" prop="fzr">
                        <el-input v-model="form.fzr" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="单位地址:">
                        <el-input v-model="form.dwdz" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="身份证地址:" prop="sfdz">
                        <el-input v-model="form.sfdz" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="住址:" prop="zhuzhi">
                        <el-input v-model="form.zhuzhi" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="违法行为所属乡街道:" prop="xiangjiedao">
                        <el-select v-model="form.xiangjiedao" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in xiangjiedaoOptions"
                                :key="dict.ID"
                                :label="dict.zgqy"
                                :value="dict.zgqy"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="性别:" prop="frxb">
                        <el-select v-model="form.frxb" placeholder="请选择性别" clearable size="small">
                            <el-option  label="男" value="男"/>
                            <el-option  label="女" value="女"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="民族:" prop="nation">
                        <el-select v-model="form.nation" placeholder="请选择民族" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in mzOptions"
                                :key="dict.id"
                                :label="dict.nation"
                                :value="dict.nation"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="职务:">
                        <el-select v-model="form.frzw" placeholder="请选择职务" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in zwOptions"
                                :key="dict.px"
                                :label="dict.zw"
                                :value="dict.zw"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="身份证号:" prop="sfzh">
                        <el-input
                        v-model="form.sfzh"
                        placeholder="请输入身份证号"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="联系电话:" prop="sj1">
                        <el-input
                        v-model="form.sj1"
                        placeholder="请输入联系电话"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                
                        <el-col :span="12">
                    <el-form-item label="统一社会信用代码:">
                        <el-input v-model="form.zzdm" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
              </el-col>
                 <el-col :span="12">   
                    <el-form-item label="违法行为发生的地址:" prop="wfxwdz">
                        <el-input v-model="form.wfxwdz" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                    <el-col :span="12">
                    <el-form-item label="违法行为发生的单位名称/场所:" prop="changsuo">
                        <el-input v-model="form.changsuo" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        
                    
                
                    </el-row>
                </el-form>
                <p>&nbsp;&nbsp;备注:</p>
                <p>&nbsp;&nbsp;1、单位（个人）和注册地址（身份证住址）均应按照营业执照或身份证相关信息准确填写用于生成被处罚主体信息。</p>
                <p>&nbsp;&nbsp;2、违法行为发生的地址和违法行为发生的单位/场所的内容用于生成现场笔录记录内容前面的描述。</p>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="onSubmit('form')">确定</el-button>
                    <el-button  size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="无证新增" :visible.sync="open2" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <h2 style="text-align:center;margin-bottom:10px;">当事人基本信息</h2>
                <el-form ref="form" :model="form" :rules="rules" label-width="160px">
                    <el-row>
                        <!-- <el-col :span="24">
                    <el-form-item label="微信选择:" prop="weixin">
                        <el-select v-model="form.weixin" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in weixinOptions"
                                :key="dict.openid"
                                :label="dict.nickname"
                                :value="dict.openid"
                                ></el-option>
                        </el-select>&nbsp;
                        <el-button type="primary" size="small" @click="getSfsb">接收身份证智能识别通知</el-button>
                    </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="性质:" prop="jingyingzhe">
                        <el-select v-model="form.jingyingzhe" placeholder="请选择" clearable size="small">
                            <!-- <el-option value="法定代表人">法定代表人</el-option>
                            <el-option value="经营者">经营者</el-option>
                            <el-option value="负责人">负责人</el-option>
                            <el-option value="个人">个人</el-option> -->
                            <el-option 
                                v-for="dict in jingyingzheOptions"
                                :key="dict.id"
                                :label="dict.jingyingzhe"
                                :value="dict.jingyingzhe"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item :label="form.jingyingzhe?(form.jingyingzhe=='个人'?'个人姓名:':form.jingyingzhe+':'):'负责人:'" prop="jingyingzheXm">
                        <el-input v-model="form.jingyingzheXm" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item label="单位名称:" prop="dwmc">
                        <el-input v-model="form.dwmc" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="form.zylb" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                    <el-form-item label="姓名:" prop="fzr">
                        <el-input v-model="form.fzr" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="注册地址:" prop="dwdz">
                        <el-input v-model="form.dwdz" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="身份证住址:" prop="zhuzhi">
                        <el-input v-model="form.zhuzhi" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="违法行为所属乡街道:" prop="xiangjiedao">
                        <el-select v-model="form.xiangjiedao" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in xiangjiedaoOptions"
                                :key="dict.ID"
                                :label="dict.zgqy"
                                :value="dict.zgqy"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="性别:" prop="frxb">
                        <el-select v-model="form.frxb" placeholder="请选择性别" clearable size="small">
                            <el-option  label="男" value="男"/>
                            <el-option  label="女" value="女"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="民族:" prop="nation">
                        <el-select v-model="form.nation" placeholder="请选择民族" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in mzOptions"
                                :key="dict.id"
                                :label="dict.nation"
                                :value="dict.nation"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="职务:" prop="frzw">
                        <el-select v-model="form.frzw" placeholder="请选择职务" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in zwOptions"
                                :key="dict.px"
                                :label="dict.zw"
                                :value="dict.zw"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="身份证号:" prop="sfzh">
                        <el-input
                        v-model="form.sfzh"
                        placeholder="请输入身份证号"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="联系电话:" prop="sj1">
                        <el-input
                        v-model="form.sj1"
                        placeholder="请输入联系电话"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="统一社会信用代码:" prop="zzdm">
                        <el-input v-model="form.zzdm" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
              
                    
                    <el-form-item label="违法行为发生的地址:" prop="wfxwdz">
                        <el-input v-model="form.wfxwdz" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="违法行为发生的单位名称/场所:" prop="changsuo">
                        <el-input v-model="form.changsuo" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    
                </el-col>
                    </el-row>
                </el-form>
                <p>&nbsp;&nbsp;备注:</p>
                <p>&nbsp;&nbsp;1、单位（个人）和注册地址（身份证住址）均应按照营业执照或身份证相关信息准确填写用于生成被处罚主体信息。</p>
                <p>&nbsp;&nbsp;2、违法行为发生的地址和违法行为发生的单位/场所的内容用于生成现场笔录记录内容前面的描述。</p>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="onSubmit('form')">确定</el-button>
                    <el-button  size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            dm:'',
            cmid:'',
            sheng:'',
            shi:'',
            xianqu:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            },
            total:0,
            wdxdrList:[],
            jingyingzheOptions:[],
            zylbOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            form:{
                c_mid: '',
                c_org: '',
                changsuo: '',
                csrq: '',
                cun:  '',
                czhm: '',
                czy:  '',
                czyid:  '',
                dwdz: '',
                dwmc:  '',
                em:  '',
                frsj:  '',
                frxb:  '',
                frxm:  '',
                frzw:  '',
                fzr:  '',
                gzbm:  '',
                gzdw:  '',
                jingyingzhe:  '',
                jingyingzheXm:  '',
                jjlx:  '',
                jydz:  '',
                lhjb:  '',
                lxdh:  '',
                nation:  '',
                sfdz:  '',
                sfzh:  '',
                sheng:  '',
                shi:  '',
                sj1:  '',
                sjfw:  '',
                wfxwdz:  '',
                wsxkzh:  '',
                xiangjiedao:  '',
                xkzh:  '',
                zylb:  '',
                zzdm:  '',
            },
            rules:{
                jingyingzhe:[
                    { required: true, message: '经营者不能为空', trigger: ['change','blur'] }
                ],
                jingyingzheXm:[
                    { required: true, message: '经营者姓名不能为空', trigger: 'blur' }
                ],
                frzw:[
                    { required: true, message: '职务不能为空', trigger: ['change','blur'] }
                ],
                frxb:[
                    { required: true, message: '性别不能为空', trigger: ['change','blur'] }
                ],
                dwmc:[
                    { required: true, message: '单位(个人)名称不能为空', trigger: 'blur' }
                ],
                zylb:[
                    { required: true, message: '专业类别不能为空', trigger: ['change','blur'] }
                ],
                nation:[
                    { required: true, message: '民族不能为空', trigger: ['change','blur'] }
                ],
                dwdz:[
                    { required: true, message: '地址不能为空', trigger: 'blur' }
                ],
                sfzh:[
                    { required: true, message: '身份证号不能为空', trigger: 'blur' }
                ],
                zzdm:[
                    { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
                ],
                changsuo:[
                    { required: true, message: '违法行为发生的单位名称/场所不能为空', trigger: 'blur' }
                ],
                wfxwdz:[
                    { required: true, message: '违法行为发生的地址不能为空', trigger: 'blur' }
                ],
            },
            xzOptions:[],
            zwOptions:[],
            mzOptions:[],
            qyOptions:[],
            xiangjiedaoOptions:[],
            sc: "",
            xg: "",
            xz: "",
            open2:false,
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '无档相对人' || ele.item == '无证库'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.sheng = user.sheng
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/selectFaRenType`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data,1194)
            if (response.data && response.data.data) {
                this.jingyingzheOptions = response.data.data || [];
            }
            this.loading = false
        })
        .catch(error => {
            this.loading = false
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   

        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions =  res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })  
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZgqy`,
            data:{
                cmid:this.cmid
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.xiangjiedaoOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
    },
    methods: {
        async getList(){
            this.wdxdrList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/wudangxiangduiren`,
                data:{
                    zylb:this.queryParams.zylb,
                    dwmc:this.queryParams.dwmc,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.wdxdrList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })

        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){
            this.form = {
                ID:'',
                c_mid: '',
                c_org: '',
                changsuo: '',
                csrq: '',
                cun:  '',
                czhm: '',
                czy:  '',
                czyid:  '',
                dwdz: '',
                dwmc:  '',
                em:  '',
                frsj:  '',
                frxb:  '',
                frxm:  '',
                frzw:  '',
                fzr:  '',
                gzbm:  '',
                gzdw:  '',
                jingyingzhe:  '',
                jingyingzheXm:  '',
                jjlx:  '',
                jydz:  '',
                lhjb:  '',
                lxdh:  '',
                nation:  '',
                sfdz:  '',
                zhuzhi: '',
                sfzh:  '',
                sheng:  '',
                shi:  '',
                sj1:  '',
                sjfw:  '',
                wfxwdz:  '',
                wsxkzh:  '',
                xiangjiedao:  '',
                xkzh:  '',
                zylb:  '',
                zzdm:  '',
            }
            this.open = true
        },
        handleSelect(row){
            this.$router.push({path:'/daxq',query:{id:row.id}})
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleEdit(row){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getIdYouOrWu`,
                data:{
                    id:row.ID,
                    wz:1
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                console.log(res)
                this.open = true
                this.form = res.data.data || {}
            }).catch(res => {
                this.$message({
                    message: '获取数据失败，请联系管理员！',
                    type: 'error'
                });
            })
        },
        handleDelete(row){
            this.$confirm("您确认要删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/deleteYouOrWu`,
                    data:{
                        id: row.ID,
                        wz:1
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    this.open = false
                    if(res.data.code == 0 && res.data.data){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getList()
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })       
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        onSubmit(form){
            console.log(this.form)
            for(var i in this.form){
                if(this.form[i] == null || this.form[i] == 'null' || this.form[i] == undefined || this.form[i] == 'undefined'){
                    this.form[i] = ''
                }
            }
            console.log(this.form)
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if(this.form.ID){
                        axios({
                            method: 'post',
                            url: this.baseUrl+`/login/editYouOrWu`,
                            data:{
                                id: this.form.ID,
                                wz:1,
                                jingyingzhe: this.form.jingyingzhe,
                                jingyingzheXm: this.form.jingyingzheXm,
                                fzr: this.form.jingyingzheXm,
                                frzw: this.form.frzw,
                                frxb: this.form.frxb,
                                dwmc: this.form.dwmc,
                                dwdz: this.form.dwdz,
                                sheng: this.sheng,
                                shi: this.shi,
                                xianqu: this.xianqu,
                                xiangjiedao: this.form.xiangjiedao,
                                sj1: this.form.sj1,
                                zylb: this.form.zylb,
                                zyzlb: '',
                                zzdm: this.form.zzdm,
                                xkzh: '',
                                xkxm: '',
                                xkzyxq: '',
                                gps: '',
                                nation: this.form.nation,
                                zhuzhi: this.form.zhuzhi,
                                sfdz: this.form.sfdz,
                                zjType: '',
                                sfzh: this.form.sfzh,
                                isCancel: '',
                                jjlx: '',
                                changsuo: this.form.changsuo,
                                wfxwdz: this.form.wfxwdz,
                            },
                            headers: { 
                                "Content-Type": "application/json"
                            },
                        }).then(res => {
                            console.log(res)
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.getList()
                            this.open = false
                        }).catch(res => {
                            this.$message({
                                message: '修改失败',
                                type: 'error'
                            });
                        })
                    }else{
                        axios({
                            method: 'post',
                            url: `${this.Global._baseUrl2}`,
                            params: {
                                act: "saveWzdw",
                                dm: `${this.dm}`,
                                c_mid: `${this.cmid}`,
                                jingyingzhe: `${escape(this.form.jingyingzhe)}`,
                                jingyingzheXm: `${escape(this.form.jingyingzheXm)}`,
                                fzr: `${escape(this.form.jingyingzheXm)}`,
                                frzw: `${escape(this.form.frzw)}`,
                                frxb: `${escape(this.form.frxb)}`,
                                dwmc: `${escape(this.form.dwmc)}`,
                                dwdz: `${escape(this.form.dwdz)}`,
                                sheng: `${escape('浙江省')}`,
                                shi: `${this.shi}`,
                                xianqu: `${this.xianqu}`,
                                xiangjiedao: `${escape(this.form.xiangjiedao)}`,
                                sj1: `${escape(this.form.sj1)}`,
                                zylb: `${escape(this.form.zylb)}`,
                                zyzlb: '',
                                zzdm: `${escape(this.form.zzdm)}`,
                                xkzh: `${escape(this.form.xkzh)}`,
                                //xkxm: `${escape(this.form.xkxm)}`,
                                //xkzyxq: `${escape(this.form.xkzyxq)}`,
                                //gps: `${escape(this.form.gps)}`,
                                nation: `${escape(this.form.nation)}`,
                                zhuzhi: `${escape(this.form.zhuzhi)}`,
                                sfdz: `${escape(this.form.sfdz)}`,
                                //zjType: `${escape(this.form.zjType)}`,
                                sfzh: `${escape(this.form.sfzh)}`,
                                //isCancel: `${escape(this.form.isCancel)}`,
                                //jjlx: `${escape(this.form.jjlx)}`,
                                changsuo: `${escape(this.form.changsuo)}`,
                                wfxwdz: `${escape(this.form.wfxwdz)}`                    
                            },
                            headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                        }).then(res => {
                            console.log(res)
                            if(res.data[0].errcode == '0'){
                                this.$message({
                                    message: '新增成功',
                                    type: 'success'
                                });
                                this.getList()
                                this.open = false
                            }else{
                                this.$message({
                                    message: '保存失败',
                                    type: 'error'
                                });
                            }
                            
                            
                        }).catch(res => {
                            this.$message({
                                message: '保存失败',
                                type: 'error'
                            });
                        })
                    }
                }
            })
        },
        cancel(){
            this.open = false
            this.form = {
                ID:'',
                c_mid: '',
                c_org: '',
                changsuo: '',
                csrq: '',
                cun:  '',
                czhm: '',
                czy:  '',
                czyid:  '',
                dwdz: '',
                dwmc:  '',
                em:  '',
                frsj:  '',
                frxb:  '',
                frxm:  '',
                frzw:  '',
                fzr:  '',
                gzbm:  '',
                gzdw:  '',
                jingyingzhe:  '',
                jingyingzheXm:  '',
                jjlx:  '',
                jydz:  '',
                lhjb:  '',
                lxdh:  '',
                nation:  '',
                sfdz:  '',
                zhuzhi: '',
                sfzh:  '',
                sheng:  '',
                shi:  '',
                sj1:  '',
                sjfw:  '',
                wfxwdz:  '',
                wsxkzh:  '',
                xiangjiedao:  '',
                xkzh:  '',
                zylb:  '',
                zzdm:  '',
            }
        },
    }
}
</script>


<style scoped>
.bq >>> .el-form-item__label{line-height: 20px;}
</style>